import { render, staticRenderFns } from "./AttendanceExpandSetting.vue?vue&type=template&id=36c49384"
import script from "./AttendanceExpandSetting.vue?vue&type=script&lang=js"
export * from "./AttendanceExpandSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports